import { PublicationStatusSchema } from "../solo-cms/publication-status";
import { z } from "zod";

// ====== Response DTO (read) ======

export const HubBannerDtoSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  url: z.string().nullable().optional(),
  imageExtraSmallFileId: z.uuid().nullable().optional(),
  imageSmallFileId: z.uuid().nullable().optional(),
  imageMediumFileId: z.uuid().nullable().optional(),
  imageLargeFileId: z.uuid().nullable().optional(),
  imageExtraSmallUrl: z.string().nullable().optional(),
  imageSmallUrl: z.string().nullable().optional(),
  imageMediumUrl: z.string().nullable().optional(),
  imageLargeUrl: z.string().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type HubBannerDto = z.infer<typeof HubBannerDtoSchema>;

// ====== Save DTOs (write) ======

const BaseHubBannerDtoSchema = z.object({
  name: z.string().min(1),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  url: z.string().nullable().optional(),
  imageExtraSmallFileId: z.uuid().nullable().optional(),
  imageSmallFileId: z.uuid().nullable().optional(),
  imageMediumFileId: z.uuid().nullable().optional(),
  imageLargeFileId: z.uuid().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
});

export const CreateHubBannerDtoSchema = BaseHubBannerDtoSchema;
export type CreateHubBannerDto = z.infer<typeof CreateHubBannerDtoSchema>;

export const UpdateHubBannerDtoSchema = BaseHubBannerDtoSchema.extend({
  id: z.uuid(),
});
export type UpdateHubBannerDto = z.infer<typeof UpdateHubBannerDtoSchema>;

export const SaveHubBannerDtoSchema = z.union([UpdateHubBannerDtoSchema, CreateHubBannerDtoSchema]);
export type SaveHubBannerDto = z.infer<typeof SaveHubBannerDtoSchema>;

// ====== Query params ======

export const GetHubBannerByIdQueryParamsSchema = z.object({
  hubBannerId: z.uuid(),
});
export type GetHubBannerByIdQueryParamsDto = z.infer<typeof GetHubBannerByIdQueryParamsSchema>;

export const GetHubBannersByPageQueryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  search: z.string().optional(),
});
export type GetHubBannersByPageQueryParamsDto = z.infer<typeof GetHubBannersByPageQueryParamsSchema>;

export const DeleteHubBannerQueryParamsSchema = z.object({
  hubBannerId: z.uuid(),
});
export type DeleteHubBannerQueryParamsDto = z.infer<typeof DeleteHubBannerQueryParamsSchema>;

// ====== Result schemas ======

export const GetHubBannersByPageResultSchema = z.object({
  data: z.array(HubBannerDtoSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
});
export type GetHubBannersByPageResultDto = z.infer<typeof GetHubBannersByPageResultSchema>;

export const GetActiveHubBannersResultSchema = z.array(HubBannerDtoSchema);
export type GetActiveHubBannersResultDto = z.infer<typeof GetActiveHubBannersResultSchema>;
